import * as CreDtos from "../CRE.dtos";

export const
    RESEARCH_REQUEST = "RESEARCH_REQUEST",
    RESEARCH_REQUEST_FAILURE = "RESEARCH_REQUEST_FAILURE",
    RESEARCH_REQUEST_SUCCESS = "RESEARCH_REQUEST_SUCCESS",
    RESEARCH_FILTER = "RESEARCH_FILTER",
    RESEARCH_ADD = "RESEARCH_ADD",
    RESEARCH_EDIT = "RESEARCH_EDIT",
    RESEARCH_CANCEL = "RESEARCH_CANCEL",
    RESEARCH_UPSERT_REQUEST = "RESEARCH_UPSERT_REQUEST",
    RESEARCH_UPSERT_REQUEST_FAILURE = "RESEARCH_UPSERT_REQUEST_FAILURE",
    RESEARCH_UPSERT_REQUEST_SUCCESS = "RESEARCH_UPSERT_REQUEST_SUCCESS"

export function researchRequest() {
    return {
        type: RESEARCH_REQUEST
    };
}

export function researchRequestSuccess(research: CreDtos.Research[], focus: CreDtos.Focus[], states: CreDtos.State[], publications: CreDtos.Publication[], people: CreDtos.People[]) {
    return {
        type: RESEARCH_REQUEST_SUCCESS,
        research,
        focus,
        states,
        publications,
        people
    };
}

export function researchRequestFailure(error) {
    return {
        type: RESEARCH_REQUEST_FAILURE,
        error
    };
}

export function researchFilter(search: string, showDisabled: boolean) {
    return {
        type: RESEARCH_FILTER,
        search,
        showDisabled
    }
}

export function researchAdd() {
    return {
        type: RESEARCH_ADD
    }
}

export function researchEdit(research: CreDtos.Research) {
    return {
        type: RESEARCH_EDIT,
        research
    }
}

export function researchCancel() {
    return {
        type: RESEARCH_CANCEL
    }
}

export function researchUpsertRequest(research: CreDtos.Research) {
    return {
        type: RESEARCH_UPSERT_REQUEST,
        research
    };
}

export function researchUpsertRequestSuccess(research: CreDtos.Research) {
    return {
        type: RESEARCH_UPSERT_REQUEST_SUCCESS,
        research
    };
}

export function researchUpsertRequestFailure(error) {
    return {
        type: RESEARCH_UPSERT_REQUEST_FAILURE,
        error
    };
}




// WEBPACK FOOTER //
// ./src/actions/research.actions.ts